import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { contentSpacingStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export const productListFiltersTitleProps: TypographyPresentationProps = {
    forwardAs: "h4",
    size: TYPOGRAPHY.size.base,
    weight: TYPOGRAPHY.weight.black,
    lineHeight: TYPOGRAPHY.lineHeight.small,
};

export const productListFiltersSectionStyles = (flat?: boolean) => css`
    ${flat ? contentSpacingStyles(null, "1.3em") : null}
    margin-top: 1.1em;
    padding-top: 1.1em;
    border-top: 1px solid ${getColor("common.border")};

    &:first-child {
        padding: 0;
        margin: 0;
        border: 0;
    }
`;

export const productListFiltersSectionFlatSpacingStyles = () => css`
    ${contentSpacingStyles(null, "1.3em")}
`;
